export default __webpack_public_path__ + "static/finops-aziende-crescita-governance-cloud-cost-optimization-innovazione-f31c4ba516d5b6b6717c9dc820a5965e.jpg";